var map = {
	"./01d.png": 32,
	"./01n.png": 33,
	"./02d.png": 34,
	"./02n.png": 35,
	"./03d.png": 36,
	"./03n.png": 37,
	"./04d.png": 38,
	"./04n.png": 39,
	"./09d.png": 40,
	"./09n.png": 41,
	"./10d.png": 42,
	"./10n.png": 43,
	"./11d.png": 44,
	"./11n.png": 45,
	"./13d.png": 46,
	"./13n.png": 47,
	"./50d.png": 48,
	"./50n.png": 49,
	"./weather-thumnail.png": 50
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9;